"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _cmsDesignComponent = require("@tencent/cms-design-component");
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatFAQ = (properties, options = {}) => {
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura,
    _properties$ifOpen = properties.ifOpen,
    ifOpen = _properties$ifOpen === void 0 ? false : _properties$ifOpen,
    _properties$mergeComp = properties.mergeComponentStatus,
    mergeComponentStatus = _properties$mergeComp === void 0 ? false : _properties$mergeComp,
    _properties$paddingTo = properties.paddingTopNum,
    paddingTopNum = _properties$paddingTo === void 0 ? '' : _properties$paddingTo,
    _properties$paddingBo = properties.paddingBottomNum,
    paddingBottomNum = _properties$paddingBo === void 0 ? '' : _properties$paddingBo; // 第一条数据是模块名称
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const list = configuration.map((item, index) => {
    const _item$titleTab = item.titleTab,
      titleTab = _item$titleTab === void 0 ? '' : _item$titleTab,
      _item$list = item.list,
      list = _item$list === void 0 ? [] : _item$list;
    const resultList = list.map((item1, index) => {
      const _item1$title = item1.title,
        title = _item1$title === void 0 ? '' : _item1$title,
        _item1$text = item1.text,
        text = _item1$text === void 0 ? '' : _item1$text;
      const formatContent = formatUrlInText(text, {
        reportEvent: 'click_faq_richtext_href'
      });
      return {
        title,
        text: formatContent
      };
    });
    return {
      key: `${index + 1}`,
      titleTab,
      list: resultList
    };
  });
  return {
    modTitle,
    configuration: list,
    bgColor: color,
    ifOpen,
    mergeComponentStatus,
    paddingTopNum,
    paddingBottomNum
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const componentData = data;
  if (componentData) {
    const _formatFAQ = formatFAQ(componentData, {
        domains
      }),
      _formatFAQ$configurat = _formatFAQ.configuration,
      configuration = _formatFAQ$configurat === void 0 ? [] : _formatFAQ$configurat,
      _formatFAQ$modTitle = _formatFAQ.modTitle,
      modTitle = _formatFAQ$modTitle === void 0 ? '' : _formatFAQ$modTitle,
      _formatFAQ$bgColor = _formatFAQ.bgColor,
      bgColor = _formatFAQ$bgColor === void 0 ? '' : _formatFAQ$bgColor,
      _formatFAQ$ifOpen = _formatFAQ.ifOpen,
      ifOpen = _formatFAQ$ifOpen === void 0 ? false : _formatFAQ$ifOpen,
      mergeComponentStatus = _formatFAQ.mergeComponentStatus,
      paddingTopNum = _formatFAQ.paddingTopNum,
      paddingBottomNum = _formatFAQ.paddingBottomNum;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_faq', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.FAQ, {
      flexTitle: modTitle,
      style: bgStyle,
      mergeComponentStatus: mergeComponentStatus,
      paddingTopNum: paddingTopNum,
      paddingBottomNum: paddingBottomNum,
      configuration: configuration,
      ifOpen: ifOpen
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}